import React from 'react';
import './ServiceCard.css';

interface ServiceCardProps {
  title: string;
  description: string;
  icon: string;
}

export const ServiceCard: React.FC<ServiceCardProps> = ({ title, description, icon }) => {
  return (
    <div className="service-card">
      <div className="service-icon">
        <i className={icon}></i>
      </div>
      <div className="service-content">
        <h3 className="service-title">{title}</h3>
        <p className="service-description">{description}</p>
      </div>
      <div className="service-arrow">
        <i className="fa-solid fa-angle-right"></i>
      </div>
    </div>
  );
};
